import React, { useState } from "react";
import "@frameworks/web/stylesheets/components/Reports/HoldingReports/MobFilterAssetDrop.scss";
import { dynamicPNLFilters } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import { initSelectedFilter, } from "./constant";
const MobPosFilterAssetDrop = ({ setShowFilterAssetDrop, setShowDot, filterData: { simpleFilter, assetFilter, expiryMonth, instrumentType, optionType, strikePrice, underlyingAsset, }, setFilterData, applyFilter, showAsset, clearSessionFilters, }) => {
    const filterData = {
        simpleFilter,
        assetFilter,
        expiryMonth,
        instrumentType,
        optionType,
        strikePrice,
        underlyingAsset,
    };
    const [selectedFilters, setselectedFilters] = useState(initSelectedFilter);
    const FiltercounterHelper = (filter, event) => {
        if (!filter)
            return [];
        const { parentNode, checked } = event.target;
        const newFilters = [...filter.filters];
        filter.filters.map((el, index) => {
            if (el.title === parentNode.textContent) {
                newFilters[index] = Object.assign(Object.assign({}, el), { selected: checked });
            }
        });
        return newFilters;
    };
    const filterCounter = (event) => {
        simpleFilter.filters = FiltercounterHelper(simpleFilter, event);
        assetFilter.filters = FiltercounterHelper(assetFilter, event);
        if (expiryMonth) {
            expiryMonth.filters = FiltercounterHelper(expiryMonth, event);
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { expiryMonth: expiryMonth.filters.filter((x) => x.selected).length });
            });
        }
        if (instrumentType) {
            instrumentType.filters = FiltercounterHelper(instrumentType, event);
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { instrumentType: instrumentType.filters.filter((x) => x.selected)
                        .length });
            });
        }
        if (optionType) {
            optionType.filters = FiltercounterHelper(optionType, event);
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { optionType: optionType.filters.filter((x) => x.selected).length });
            });
        }
        if (strikePrice) {
            strikePrice.filters = FiltercounterHelper(strikePrice, event);
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { strikePrice: strikePrice.filters.filter((x) => x.selected).length });
            });
        }
        if (underlyingAsset) {
            underlyingAsset.filters = FiltercounterHelper(underlyingAsset, event);
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { underlyingAsset: underlyingAsset.filters.filter((x) => x.selected)
                        .length });
            });
        }
        if (showAsset)
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { assetFilter: assetFilter.filters.filter((x) => x.selected).length });
            });
        else
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { assetFilter: 0 });
            });
        setselectedFilters((prevState) => {
            return Object.assign(Object.assign({}, prevState), { simpleFilter: simpleFilter.filters.filter((x) => x.selected).length });
        });
    };
    const applyFilterHandle = () => {
        applyFilter();
        if (!showAsset) {
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { assetFilter: 0 });
            });
        }
        setShowFilterAssetDrop(false);
        let count = Object.values(selectedFilters).reduce((prevFilterCount, currCount) => prevFilterCount + currCount, 0);
        setShowDot(count);
    };
    const removeFilter = (filter) => {
        return filter.map((filter) => {
            if (filter.selected)
                filter.selected = false;
            return filter;
        });
    };
    const clearAllFilter = () => {
        setselectedFilters(initSelectedFilter);
        setFilterData((prevState) => {
            let clearState = {
                simpleFilter: {
                    name: simpleFilter.name,
                    filters: removeFilter(simpleFilter.filters),
                },
                assetFilter: {
                    name: "Asset filter",
                    filters: showAsset
                        ? removeFilter(assetFilter === null || assetFilter === void 0 ? void 0 : assetFilter.filters)
                        : [],
                },
            };
            if (expiryMonth)
                clearState.expiryMonth = {
                    name: expiryMonth.name,
                    filters: removeFilter(expiryMonth.filters),
                };
            if (instrumentType)
                clearState.instrumentType = {
                    name: instrumentType.name,
                    filters: removeFilter(instrumentType.filters),
                };
            if (underlyingAsset)
                clearState.underlyingAsset = {
                    name: underlyingAsset.name,
                    filters: removeFilter(underlyingAsset.filters),
                };
            if (strikePrice)
                clearState.strikePrice = {
                    name: strikePrice.name,
                    filters: removeFilter(strikePrice.filters),
                };
            if (optionType)
                clearState.optionType = {
                    name: optionType.name,
                    filters: removeFilter(optionType.filters),
                };
            return clearState;
        });
        clearSessionFilters();
        applyFilter();
        setShowFilterAssetDrop(false);
        setShowDot(0);
    };
    const DynamicFilters = (filters) => {
        var _a, _b;
        if (filters && ((_a = filters.filters) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement("p", { className: "bodyhead" }, dynamicPNLFilters[filters.name]),
                React.createElement("ul", { className: "bodylist unsetHeight", id: "filter" }, (_b = filters === null || filters === void 0 ? void 0 : filters.filters) === null || _b === void 0 ? void 0 : _b.map((val, idx) => {
                    return (React.createElement("li", { key: idx },
                        React.createElement("label", { className: "checkbox" },
                            React.createElement("input", { type: "checkbox", checked: val.selected, onChange: filterCounter }),
                            React.createElement("span", { className: "checked edel-icon-tick" }),
                            React.createElement("p", { className: "bodylist-title" }, val.title))));
                }))));
        }
    };
    const enableApply = () => {
        for (let key in selectedFilters)
            if (selectedFilters[key] > 0)
                return true;
        return false;
    };
    const InitSelectedFilters = () => {
        let filterCounts = Object.assign({}, initSelectedFilter);
        for (let key in filterData) {
            if (filterData[key]) {
                let filterCount = filterData[key].filters.filter((x) => x.selected).length;
                if (filterCount > 0)
                    filterCounts[key] = filterCount;
            }
        }
        setselectedFilters(filterCounts);
    };
    React.useEffect(() => {
        InitSelectedFilters();
    }, []);
    return (React.createElement("div", { className: "mob-filterasset-drop" },
        React.createElement("div", { className: "mob-filterasset-drop-head" },
            React.createElement("div", { className: "down-bar container" },
                React.createElement("span", { className: "down-bar-left" }, "Filters"),
                React.createElement("input", { onClick: clearAllFilter, className: "down-bar-right", type: "button", value: "Clear All" }))),
        React.createElement("div", { className: "mob-filterasset-drop-body filterBottomScroll vh-100 overflow-scroll" }, Object.entries(filterData).map((val) => {
            React.createElement("div", { className: "filter-asset-seperator" });
            if (val[0] == "assetFilter")
                return showAsset && DynamicFilters(val[1]);
            return DynamicFilters(val[1]);
        })),
        React.createElement("div", { className: "mob-filterasset-drop-footer" },
            React.createElement("input", { type: "button", className: enableApply() ? "filter-button aply-btn" : "filter-button-disable", value: "Apply Filters", onClick: applyFilterHandle }))));
};
export default MobPosFilterAssetDrop;
